import Heading from '@atoms/Heading/Heading';
import Text from '@atoms/Text/Text';
import { StyledInfoBlock } from './ProductTableOfOther.styles';
import { useTranslations } from 'next-intl';
import type { ProductContactInfoData } from '@occ/api-client';

interface Props {
  contacts?: ProductContactInfoData[];
  name?: string;
  address?: string;
}

const Contact = ({ contacts, name, address }: Props) => {
  const t = useTranslations('product');

  const hasContacts = contacts && contacts.length > 0;
  const hasFallback = name || address;

  if (!hasContacts && !hasFallback) return null;

  if (hasContacts) {
    return (
      <>
        {contacts.map(({ type, name, address, details }, index) => (
          <StyledInfoBlock key={index}>
            <Heading variant="h3" label>
              {t(`contactType.${type}`)}
            </Heading>
            {name && <Text type="body">{name}</Text>}
            {address && <Text type="body">{address}</Text>}
            {details &&
              details.map(({ method, details: detailValue }) => (
                <Text key={`${method}-${detailValue}`} type="body">
                  {detailValue}
                </Text>
              ))}
          </StyledInfoBlock>
        ))}
      </>
    );
  }

  return (
    <StyledInfoBlock>
      <Heading variant="h3" label>
        {t('contact')}
      </Heading>
      {name && <Text type="body">{name}</Text>}
      {address && <Text type="body">{address}</Text>}
    </StyledInfoBlock>
  );
};

export default Contact;
